export default __webpack_public_path__ + "static/media/Grupo 25@2x.7891d05f.png";